import { Injectable, NgZone } from '@angular/core';
import { DialogService, IDialogHandle } from '../dialogs/dialog.service';
import { DialogCloseReason, IDialogOnClose } from '../dialogs/base-dialog';
import { TranslateService } from '@ngx-translate/core';
import editor = CKEDITOR.editor;
import IPluginDefinition = CKEDITOR.plugins.IPluginDefinition;
import { PersonalizationDialogComponent } from './personalization-dialog-component';

@Injectable({ providedIn: 'root' }) //consume this service as Injectable so we could have the translation service injected to it.
export class CkEditorPersonalizationPluginService implements IPluginDefinition {

  toolbarTooltipCaption: string;

  constructor(private dialogService: DialogService,
    public zone: NgZone,
    private translate: TranslateService
  ) {
    this.toolbarTooltipCaption = this.translate.instant('COMMON.DIALOGS.PERSONALIZATION.CK_EDITOR_BUTTON_LABEL');
    CKEDITOR.plugins.add('cd-personalization', this);
  }

  init(editor: editor): any {

    editor.addCommand('personalizationCommand', {
      exec: (editor: any) => {
        this.openPersonalizationDialog(editor);
        return true;
      }
    });

    if (editor.ui.addButton) {
      editor.ui.addButton('CdPersonalization', {
        label: this.toolbarTooltipCaption,
        command: 'personalizationCommand',
        toolbar: 'clickDimensionsActions',
        icon: `/assets/common-lib/images/person-silhouette.png`
      });
    }
  }

  openPersonalizationDialog(editor: editor) {
    let selection = editor.getSelection();
    let range = selection.getRanges()[0];
    editor.focusManager.lock();

    let dialogHandle: IDialogHandle = this.dialogService.createDialog<PersonalizationDialogComponent>(PersonalizationDialogComponent);
    dialogHandle.onClose.subscribe((result: IDialogOnClose) => {
      if (result.reason === DialogCloseReason.OK) {
        editor.insertText(result.data);
      }

      editor.focusManager.unlock();

      let pCon = range.startContainer.getAscendant({ p: 2 }, true);
      if (pCon) {
        let newRange: CKEDITOR.dom.range = new CKEDITOR.dom.range(range.document);
        newRange.moveToPosition(pCon, CKEDITOR.POSITION_BEFORE_START);
        newRange.select();
      }

      editor.focus();
    });
  }
}
